import { render, staticRenderFns } from "./sweet-alert.vue?vue&type=template&id=0deb01d3&"
import script from "./sweet-alert.vue?vue&type=script&lang=js&"
export * from "./sweet-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports